export default __webpack_public_path__ + "static/media/amana.e16598c3.svg";